import { render, staticRenderFns } from "./translations.vue?vue&type=template&id=75e44734&scoped=true&"
import script from "./translations.ts?vue&type=script&lang=ts&"
export * from "./translations.ts?vue&type=script&lang=ts&"
import style0 from "./translations.scss?vue&type=style&index=0&id=75e44734&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e44734",
  null
  
)

export default component.exports